<template>
  <div id="app">
    <nav class="topBar">
      <div class="content">
        <div class="logo">
          <img src="./assets/App/logo.png" alt=""/>
        </div>
        <div class="navigationBar">
          <div class="barItem"
               v-for="(item, index) in topBarData"
               :class="{ selected: item.selected }"
               :key="index"
               @mouseenter="mouseEnter(item, 1)"
               @mouseleave="mouseLeave(item, 1)"
               @click="clickNavigationItem(item)">
            <span>{{ item['name'] }}</span>
            <!-- <div class="floatingBox"
                 @mouseleave="mouseLeave(item, 2)"
                 @mouseenter="mouseEnter(item, 2)"
                 v-if="item['type'] === 2">
              <div class="floatingBoxItem"
                   v-for="(childItem, childIndex) in item['child']"
                   :key="childIndex"
                   :class="{ selected: childItem.selected }"
                   @click="clickFloatingBox(childItem)">
                <div class="boxItem">{{ childItem['name'] }}</div>
              </div>
            </div> -->
          </div>
        </div>
        <div class="rightText">
          <div class="text1">政府指定机票供应商</div>
<!--           <div class="text2">股权代码 201753</div>
 -->        </div>
      </div>
    </nav>
    <keep-alive>
      <router-view/>
    </keep-alive>
    <div class="footer">
      <div class="generality">
        <img src="./assets/App/logo02.png" alt="" class="logo"/>
        <div class="telPanel">
          <div class="div1">服务热线</div>
          <div class="div2" style="color: #EA5504;">400-620-8989</div>
          <div class="div3">021-6263 1111（上海）</div>
        </div>
        <div class="contactDetails">
          <div class="div1">总部地址</div>
          <div class="div2">
            上海市普陀区常德路1339号金昌商务中心B幢6楼
          </div>
<!--           <div class="div2">分部地址</div>
          <div class="div2">
            上海浦东机场航站楼 T1 H岛40柜台 T2 A岛2号柜台
          </div> -->
        </div>
        <div class="codePanel">
          <img src="./assets/App/weiBoBg.png" alt="" @mouseenter="showCode(1)" @mouseleave="leaveCode(1)" class="logoImg">
          <img src="./assets/App/weChatBg.png" alt="" @mouseenter="showCode(2)" @mouseleave="leaveCode(2)" class="logoImg">
          <div class="codeBg">
            <transition name="el-zoom-in-center">
              <img src="./assets/App/weiBoCode02.png" alt="" v-show="show1">
            </transition>
            <transition name="el-zoom-in-center">
              <img src="./assets/App/erweima02.jpg" alt="" v-show="show2">
            </transition>
          </div>
        </div>
      </div>
      <div class="remark">
        <p>Copyright @ 2012-2020, chengduoduo.com.All rights reserved. | <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备09032775号</a></p>
        <div style="width:300px;margin:0 auto; padding:20px 0;">
        	<a  id="_xinchacharenzheng_cert_vip_kexinweb"  style="text-decoration:none;"  target="_blank"  href="https://xyt.xinchacha.com/pcinfo?sn=1404991645756534784&certType=6">
        	      <img src="./assets/App/icon3.png" style="height:50px;width:137px;">
        	</a>
			<a href="https://xyt.xcc.cn/getpcInfo?sn=1544518957669490688&certType=8&url=*.chengduoduo.com">
        <img src="./assets/App/icon8.png"style="height:50px;width:164px;"></a>
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010702006904" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
          <img src="" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">沪公网安备 31010702006904号</p>
          </a>
        </div>

      </div>
    </div>
  </div>
</template>
<script name="baidu-koubei-verification" src="//ikoubei.baidu.com/embed/b2cafbc9d858b967408dad4f522e56ed"></script>
<script>
  import $ from 'jquery'
  import 'element-ui/lib/theme-chalk/base.css';
  import router from './router'

  export default {
    name: 'App',
    data() {
      return {
        show1: false,
        show2: false,
        topBarFlag: true,
        topBarData: [
          {
            name: '首页',
            selected: true,
            type: 1
          },
          // {
          //   name: '节省方案',
          //   selected: false,
          //   type: 2,
          //   child: [
          //     {
          //       name: '企业差旅',
          //       selected: false,
          //       type: 1
          //     },
          //     {
          //       name: '奖励旅游',
          //       selected: false,
          //       type: 2
          //     },
          //     {
          //       name: '会务会展',
          //       selected: false,
          //       type: 3
          //     }
          //   ]
          // },
          {
            name: '企业商旅',
            selected: false,
            type: 2,
          },
          // {
          //   name: '奖励旅游',
          //   selected: false,
          //   type: 3
          // },
          // {
          //   name: '会务团建',
          //   selected: false,
          //   type: 4
          // },
          {
            name: '公务机票',
            selected: false,
            type:9
          },
          {
            name: '增值服务',
            selected: false,
            type: 10
          },
          // {
          //   name: '服务体验',
          //   selected: false,
          //   type: 3,
          //   child: [
          //     {
          //       name: '品牌建设',
          //       selected: false,
          //       type: 1
          //     },
          //     {
          //       name: '技术开发',
          //       selected: false,
          //       type: 2
          //     },
          //     {
          //       name: '企业团建',
          //       selected: false,
          //       type: 3
          //     },
          //     {
          //       name: '企业服务',
          //       selected: false,
          //       type: 4
          //     }
          //   ]
          // },
          // {
          //   name: '服务案例',
          //   selected: false,
          //   type: 4
          // },
          {
            name: '新闻资讯',
            selected: false,
            type: 5
          },
          {
            name: '关于我们',
            selected: false,
            type: 6
          },
          // {
          //   name: '上海程多多电子商务有限公司旅业',
          //   selected: false,
          //   type: 7
          // },
          {
            name: '商旅系统',
            selected: false,
            type: 8
          }
        ]
      }
    },
    created() {

    },
    methods: {
      showCode(type) {
        if (type === 1) {
          this.show1 = true
        } else {
          this.show2 = true
        }
      },
      leaveCode(type) {
        if (type === 1) {
          this.show1 = false
        } else {
          this.show2 = false
        }
      },
      mouseEnter(item, type) {
        let box = $('.floatingBox');
        if (type === 1) {
          switch (item['type']) {
            case 2:
              box.addClass('open');
              this.topBarFlag = false;
              break;
            default:
              box.removeClass('open');
              this.topBarFlag = true;
              break
          }
        } else {
          this.topBarFlag = false
        }
      },
      mouseLeave(item, type) {
        this.topBarFlag = true;
        setTimeout(function () {
          let box = $('.floatingBox');
          if (type === 1) {
            if (this.topBarFlag) {
              switch (item['type']) {
                case 2:
                  box.removeClass('open');
                  this.topBarFlag = false;
                  break;
                default:
                  box.removeClass('open');
                  this.topBarFlag = true;
                  break
              }
            }
          } else {
            if (this.topBarFlag) {
              switch (item['type']) {
                case 2:
                  box.removeClass('open');
                  this.topBarFlag = false;
                  break;
                default:
                  box.removeClass('open');
                  this.topBarFlag = true;
                  break
              }
            }
            this.topBarFlag = true
          }
        }, 150)
      },

      clickNavigationItem(item) {
        let newArr = [];
        let arr = JSON.parse(JSON.stringify(this.topBarData));
        arr.forEach(function (value) {
            let obj = value;
            if(item.type == value.type){
              value.selected = 'selected'
            }else{
              value.selected = ''
            }
            newArr.push(obj);
        });

        this.topBarData = newArr;

        switch (item['type']) {
          case 1:
            this.$router.push({path: '/home'});
            break;
          case 2:
            this.$router.push({
              path: '/corporateTravel'
            });
            break;
          case 3:
            // this.$router.push({
            //   path: '/serviceExperience'
            // });
            // item['selected'] = true;
            window.open('https://travel.chengduoduo.com/');
            break;
          case 4:
            // this.$router.push({
            //   path: '/serviceCase'
            // });
            // item['selected'] = true;
            alert('会展团建模块正在开发中……');
            // window.open('https://mice.chengduoduo.com/');
            break;
          case 5:
            this.$router.push({
              path: '/news'
            });
            break;
          case 6:
            this.$router.push({
              path: '/aboutUs'
            });
            break;
          case 7:
            window.open('https://agent.chengduoduo.com/')
            break;
          case 8:
            window.open('https://tmc.chengduoduo.com/')
            break;
           case 9:
             this.$router.push({
               path: '/serviceCase'
             });
             break;
           case 10:
             this.$router.push({
               path: '/serviceExperience'
             });
             break;
        }
      },









      clickFloatingBox(item) {
        let ev = window.event;
        if (window.event) {
          ev.cancelBubble = true
        } else {
          ev.stopPropagation()
        }
        this.topBarData.map(function (value) {
          value.selected = false
        });
        this.topBarData[1].selected = true;
        this.topBarData[1]['child'].map(function (value) {
          value.selected = false
        });
        item.selected = true;
        switch (item.type) {
          case 1:
            this.$router.push({
              path: '/corporateTravel'
            });
            break;
          case 2:
            window.open('https://travel.chengduoduo.com/');
            //this.$router.push({
              //path: '/incentiveTravel'

            //});
            break;
          case 3:
            window.open('https://mice.chengduoduo.com/');
            //this.$router.push({
              //path: '/conference'
            //});
            break;
        }
      },
    }
  }
</script>
<style lang="less">
  @import 'css/App.less';
</style>



// WEBPACK FOOTER //
// src/App.vue